export enum PAGINE_CABALA_PATH {
  'NUMERI_NOME' = '/numeri-caldi-nomi',
  'NUMERI_TEST' = '/numeri-fortunati-sogni',
  'NUMERI_AMORE' = '/numeri-caldi-amore',
  'NUMERI_CUCINA' = '/numeri-vincenti-cucina',
  'NUMERI_OROSCOPO' = '/numeri-fortunati-oroscopo'
}

export enum TEST_PSICOLOTTICO {
  LupoAgnello = 'La tua indole è quella di un lupo o di un agnello.',
  GodersiVita = 'Quanto sai goderti la vita?',
  PaperoneGastone = 'Sei Paperone o Gastone?'
}

export enum SIGNAL_EVENT {
  showLoader = 'showLoader'
}

export enum STAR_SIGN {
  ariete = 'Ariete',
  toro = 'Toro',
  gemelli = 'Gemelli',
  cancro = 'Cancro',
  leone = 'Leone',
  vergine = 'Vergine',
  bilancia = 'Bilancia',
  scorpione = 'Scorpione',
  sagittario = 'Sagittario',
  capricorno = 'Capricorno',
  acquario = 'Acquario',
  pesci = 'Pesci'
}

export enum ERROR_CAUSE {
  NotOk,
  BadRequest,
  EmptyNumber
}

export enum ERROR_MESSAGE {
  msgEmptyNumber = 'Empty numbers in server response',
  msgInvalidName = 'Il nome non è valido',
  msgRetry = 'Riprova'
}
